var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_675_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.136 2.11182H10.9058V17.6361H20.136V2.11182Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8371 9.87402C11.8374 8.38057 12.1654 6.90656 12.7965 5.56233C13.4275 4.21811 14.3454 3.03852 15.4812 2.11189C14.0686 0.966688 12.3721 0.254417 10.5855 0.056499C8.79887 -0.141419 6.99431 0.183003 5.37807 0.992679C3.76184 1.80236 2.39914 3.06461 1.44577 4.63516C0.492399 6.20571 -0.0131836 8.02117 -0.0131836 9.87402C-0.0131836 11.7269 0.492399 13.5423 1.44577 15.1129C2.39914 16.6834 3.76184 17.9457 5.37807 18.7554C6.99431 19.565 8.79887 19.8894 10.5855 19.6915C12.3721 19.4936 14.0686 18.7813 15.4812 17.6361C14.3454 16.7095 13.4275 15.5299 12.7965 14.1857C12.1654 12.8415 11.8374 11.3675 11.8371 9.87402Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9894 9.87416C30.9907 11.7257 30.4867 13.5402 29.5348 15.1101C28.583 16.6801 27.2219 17.9421 25.6072 18.7519C23.9925 19.5617 22.1893 19.8865 20.4039 19.6892C18.6186 19.4919 16.9231 18.7805 15.5115 17.6363C16.6476 16.7099 17.5656 15.5304 18.1967 14.1861C18.8278 12.8418 19.1556 11.3677 19.1556 9.87416C19.1556 8.38065 18.8278 6.90651 18.1967 5.56224C17.5656 4.21797 16.6476 3.03843 15.5115 2.11204C16.9231 0.967823 18.6186 0.256387 20.4039 0.0590957C22.1893 -0.138195 23.9925 0.186625 25.6072 0.996406C27.2219 1.80619 28.583 3.06823 29.5348 4.6382C30.4867 6.20817 30.9907 8.02266 30.9894 9.87416Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_675_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.bbfc4f7441ee70c5ae6811173438ea86.svg";
export { ForwardRef as ReactComponent };